import { Map, is } from 'immutable';
import { chain, reduce, values } from 'ramda';

export default function(reducers, operatorRecords) {
  let keys = Object.keys(reducers);

  let defaultState = reduce((state, key) => {
    return state.set(key, reducers[key]());
  }, Map(), keys);

  return function reducer(state = defaultState, action, createEvent) {
    return reduce((state, key) => {
      let previousStateForKey = state.get(key);
      let nextStateForKey = reducers[key](previousStateForKey, action, state, createEvent);
      if (__DEV__) {
        if (!nextStateForKey) {
          throw new Error(`Reducer: ${key} failed to return state`);
        }
      }

      return is(previousStateForKey, nextStateForKey) ? state : state.set(key, nextStateForKey);
    }, state, keys);
  };
};




// WEBPACK FOOTER //
// ./src/store/createReducer.js